import Head from 'next/head'

import FarmbookHeader from '@/components/farmbookHeader'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import { PAGE_TYPE, STRINGS } from '@/constants/farmbook'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const Twitter = () => {
  return (
    <>
      <Head>
        <script async src="https://platform.twitter.com/widgets.js" />
      </Head>
      <LayoutWithNavigation>
        <section className="px-6 my-4 max-w-7xl m-auto">
          <FarmbookHeader activePage={PAGE_TYPE.TWITTER} />
          <section className="mt-[30px] md:w-2/3 w-full">
            <a
              className="twitter-timeline block animate-pulse"
              href="https://twitter.com/DeHaatTM?ref_src=twsrc%5Etfw"
            >
              {STRINGS.TWEETS}
            </a>
          </section>
        </section>
      </LayoutWithNavigation>
    </>
  )
}

export default Twitter
